import { Button, InputNumber } from "antd"

const buttonStyle = {
  width: 40,
  height: 40,
  borderRadius: 0,
}

const BlockCountStepper = ({ count, onChange, min = 1, max = 99, disabled = false }) => {
  const value = +count
  const current = value >= min ? value : min

  const dec = () => onChange?.(Math.max(min, current - 1))
  const inc = () => onChange?.(Math.min(max, current + 1))

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #e5e5e5",
        borderRadius: 10,
        overflow: "hidden",
        width: "fit-content",
        background: "#f5f5f5",
      }}
    >
      <Button type="text" onClick={dec} disabled={disabled || current <= min} style={{ ...buttonStyle }}>
        −
      </Button>
      <InputNumber
        value={current}
        controls={false}
        disabled={disabled}
        min={min}
        max={max}
        onChange={n => {
          if (n == null || n === "") return
          const num = +n
          onChange?.(Math.min(max, Math.max(min, num)))
        }}
        style={{
          width: 50,
          height: 40,
          border: "none",
          textAlignLast: "center",
          background: "#fff",
        }}
      />
      <Button type="text" onClick={inc} disabled={disabled || current >= max} style={{ ...buttonStyle }}>
        +
      </Button>
    </div>
  )
}

export default BlockCountStepper
